// Smart Sash Admin Panel - Button Component

import React from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'link';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  outline?: boolean;
  loading?: boolean;
  icon?: string;
  fullWidth?: boolean;
  children?: React.ReactNode;
}

/**
 * Reusable Button Component
 * Wraps Bootstrap button with additional features
 */
export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  outline = false,
  loading = false,
  icon,
  fullWidth = false,
  disabled,
  className = '',
  children,
  ...props
}) => {
  const sizeClass = size === 'md' ? '' : `btn-${size}`;
  const variantClass = outline ? `btn-outline-${variant}` : `btn-${variant}`;
  const widthClass = fullWidth ? 'w-100' : '';

  const classes = [
    'btn',
    variantClass,
    sizeClass,
    widthClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={classes}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      )}
      {!loading && icon && (
        <i className={`${icon} me-2`}></i>
      )}
      {children}
    </button>
  );
};

export default Button;
